import { moveToFulfilled, update } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  AllCampaignsLoadFulfilledAction,
  CampaignsListLoadMoreFulfilledAction,
} from '../../domains/allCampaigns/actions.types';
import { CampaignCoverImageDeleteFulfilledAction } from '../../domains/campaignCoverImage/deleteActions.types';
import { CampaignCoverImageUploadFulfilledAction } from '../../domains/campaignCoverImage/uploadActions.types';
import { CampaignEditFulfilledAction, CampaignPublishFulfilledAction } from '../../domains/campaignEdit/actions.types';
import { CampaignLoadFulfilledAction } from '../../domains/campaigns/actions.types';
import { MyLeaderSponsoredCampaignsLoadFulfilledAction } from '../../domains/myLeaderSponsoredCampaigns/actions.types';
import { MarkAllNotificationsAsSeenFulfilledAction } from '../../domains/notificationFeeds/actions.types';
import { NotificationLoadMoreFulfilledAction } from '../../domains/notificationPaginations/actions.types';
import { SearchLoadFulfilledAction, SearchLoadMoreFulfilledAction } from '../../domains/searches/actions.types';
import { TrendingCampaignsLoadFulfilledAction } from '../../domains/trendingCampaigns/loadActions.types';
import { UserSidebarLoadFulfilledAction } from '../../domains/userSidebarLoad/actions.types';

import { CampaignCoverImages } from './types';

export type CampaignCoverImagesAction =
  | SearchLoadFulfilledAction
  | SearchLoadMoreFulfilledAction
  | AllCampaignsLoadFulfilledAction
  | NotificationLoadMoreFulfilledAction
  | CampaignsListLoadMoreFulfilledAction
  | TrendingCampaignsLoadFulfilledAction
  | MyLeaderSponsoredCampaignsLoadFulfilledAction
  | CampaignLoadFulfilledAction
  | CampaignEditFulfilledAction
  | CampaignPublishFulfilledAction
  | CampaignCoverImageUploadFulfilledAction
  | CampaignCoverImageDeleteFulfilledAction
  | UserSidebarLoadFulfilledAction
  | MarkAllNotificationsAsSeenFulfilledAction;

const initialState: CampaignCoverImages = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<CampaignCoverImages, CampaignCoverImagesAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SEARCH.LOAD_FULFILLED':
    case 'SEARCH.LOAD_MORE_FULFILLED':
    case 'ALL_CAMPAIGNS.LOAD_FULFILLED':
    case 'ALL_CAMPAIGNS.LOAD_MORE_FULFILLED':
    case 'MY_LEADER_SPONSORED_CAMPAIGNS.LOAD_FULFILLED':
    case 'TRENDING_CAMPAIGNS.LOAD_FULFILLED':
    case 'CAMPAIGN.LOAD_FULFILLED':
    case 'CAMPAIGN.EDIT_FULFILLED':
    case 'CAMPAIGN.PUBLISH_FULFILLED':
    case 'USER_SIDEBAR.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaignCoverImages);
    case 'CAMPAIGN_COVER_IMAGE.UPLOAD_FULFILLED':
      return update(state, action.payload.campaignId, {
        coverImageUrlTemplate: action.payload.coverImageUrlTemplate,
        hasDefaultCoverImage: false,
      });
    case 'CAMPAIGN_COVER_IMAGE.DELETE_FULFILLED':
      return update(state, action.payload.campaignId, {
        coverImageUrlTemplate: action.payload.coverImageUrlTemplate,
        hasDefaultCoverImage: action.payload.hasDefaultCoverImage,
      });
    case 'MARK_ALL_NOTIFICATIONS_AS_SEEN.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaignCoverImages);
    case 'NOTIFICATION.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaignCoverImages);
    default:
      return state;
  }
};

export default reducer;
